export default "<div class=\"wrapper wrapper-content  animated fadeInRight\">\n    <app-apiKey-form (onsubmit)=\"save($event)\"></app-apiKey-form>\n</div>\n";